export default __webpack_public_path__ + "static/image-placeholder-f819814e743cc15a88a22d72a15e5fe7.jpg";